export const DEFAULT_CHAT_APPEARANCE = {
  theme: "auto",
  outgoingColor: "#d9fdd3",
  incomingColor: "#ffffff",
  backgroundColor: "#efeae2",
  pattern: "doodles",
  wallpaper: "",
};

export const CHAT_STYLE_PRESETS = [
  { id: "whatsapp", name: "WhatsApp claro", outgoingColor: "#d9fdd3", incomingColor: "#ffffff", backgroundColor: "#efeae2" },
  { id: "noche", name: "WhatsApp noche", outgoingColor: "#005c4b", incomingColor: "#202c33", backgroundColor: "#0b141a" },
  { id: "lavanda", name: "Lavanda", outgoingColor: "#e5dcff", incomingColor: "#ffffff", backgroundColor: "#f1edf8" },
  { id: "oceano", name: "Océano", outgoingColor: "#cceeff", incomingColor: "#ffffff", backgroundColor: "#e7f0f5" },
  { id: "rosa", name: "Rosa", outgoingColor: "#fbd9e8", incomingColor: "#ffffff", backgroundColor: "#f8edf2" },
  { id: "arena", name: "Arena", outgoingColor: "#edd9bf", incomingColor: "#fffdf8", backgroundColor: "#f2e9dc" },
];

export const CHAT_COLOR_PALETTE = [
  "#d9fdd3", "#005c4b", "#176b4a", "#134d3c", "#e5dcff", "#6c55f5", "#49328f", "#2d2858",
  "#fbd9e8", "#9a3eb0", "#602374", "#c36536", "#824128", "#cceeff", "#0c69a5", "#103d64",
  "#dcecb4", "#6f8f3b", "#40593b", "#f4de9a", "#c19c16", "#f9c4c4", "#a71d40", "#651627",
  "#ffffff", "#efeae2", "#e7edf0", "#bebebe", "#62676b", "#303639", "#202c33", "#0b141a",
];

function luminance(color) {
  const rgb = color.replace("#", "").match(/.{2}/g).map((value) => {
    const channel = parseInt(value, 16) / 255;
    return channel <= .04045 ? channel / 12.92 : Math.pow((channel + .055) / 1.055, 2.4);
  });
  return .2126 * rgb[0] + .7152 * rgb[1] + .0722 * rgb[2];
}

export function chatTextColor(background) {
  return luminance(background) > .179 ? "#111b21" : "#f7fafb";
}

export function resolveChatAppearance(value, darkMode = false) {
  const appearance = { ...DEFAULT_CHAT_APPEARANCE, ...value };
  if (appearance.theme === "auto") {
    Object.assign(appearance, CHAT_STYLE_PRESETS[darkMode ? 1 : 0]);
  }
  return appearance;
}

export function chatSurfaceStyle(appearance) {
  const dark = chatTextColor(appearance.backgroundColor) === "#f7fafb";
  const stroke = dark ? "#ffffff" : "#3d5149";
  const doodles = `<svg xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240"><g fill="none" stroke="${stroke}" stroke-width="1.5" opacity=".09" stroke-linecap="round" stroke-linejoin="round"><path d="M20 26h28v19H33l-9 6v-6h-4zM25 32h17m-17 6h11M104 17l4 9 10 1-8 7 2 10-8-5-9 5 2-10-8-7 11-1zM177 24c-10-12-23 3 0 18 23-15 10-30 0-18zM49 97c-19-16-35 9-13 24 22-15 6-40-13-24M115 79l-10 10 10 10m14-20 10 10-10 10M186 91h28v18h-15l-9 6v-6h-4zM20 178l7-17 7 17-14-7h20M90 162c-13-13-27 6-9 18 18-12 4-31-9-18M161 166a13 13 0 1 0 26 0 13 13 0 1 0-26 0m6-3 4 4 7-8M206 206l4 8 9 2-7 6 1 9-7-4-8 4 2-9-7-6 9-2zM65 210h25m-20-7 15 14M150 220c-10 0-10-18 0-18s10 18 0 18z"/><circle cx="69" cy="57" r="3"/><circle cx="151" cy="58" r="3"/><circle cx="65" cy="148" r="3"/><path d="m143 131 9 4m-5-9 2 14M13 128l8 3m-4-7 1 11M221 42l7 4m-2-9-3 13"/></g></svg>`;
  const pattern = appearance.pattern === "doodles"
    ? `url("data:image/svg+xml,${encodeURIComponent(doodles)}")`
    : appearance.pattern === "dots"
      ? `radial-gradient(circle at 2px 2px, ${dark ? "rgba(255,255,255,.08)" : "rgba(40,60,50,.09)"} 1px, transparent 0)`
      : "none";
  return {
    backgroundColor: appearance.backgroundColor,
    backgroundImage: appearance.wallpaper ? `url("${appearance.wallpaper}")` : pattern,
    backgroundSize: appearance.wallpaper ? "cover" : appearance.pattern === "dots" ? "22px 22px" : "240px 240px",
    backgroundPosition: "center",
    backgroundRepeat: appearance.wallpaper ? "no-repeat" : "repeat",
  };
}

export function chatCssVariables(appearance) {
  return {
    "--chat-incoming": appearance.incomingColor,
    "--chat-outgoing": appearance.outgoingColor,
    "--chat-incoming-text": chatTextColor(appearance.incomingColor),
    "--chat-outgoing-text": chatTextColor(appearance.outgoingColor),
  };
}
